import { useEbbne } from "@solidwhite/ebbnen";
import { useTranslation } from "react-i18next";
import Hotspot from "../ui/Hotspot";

const EbbnenLabel = ({ hotspot, delay = 0, isAnimation = false, ...props }) => {
  const { selectable, select } = useEbbne();

  const { t } = useTranslation();

  const handleLabelClick = (e) => {
    e.stopPropagation();
    select();
  };

  return (
    selectable && (
      <Hotspot
        position={hotspot.position}
        text={hotspot.userData.textId ? t(hotspot.userData.textId) : hotspot.name.toUpperCase()}
        topLeft
        onClick={(e) => handleLabelClick(e)}
        delay={20 + 300 * delay}
        id={hotspot.name}
        isAnimation={isAnimation}
      />
    )
  );
};

export default EbbnenLabel;
